import React from 'react';

import Nav from '../components/Nav';
import Header from '../components/Header';
import Footer from '../components/Footer';

function ContactUs() {
  return (
    <>
        <Nav />
        <Header />
        <section class="wrapper inner-banner-wrapper testimonial-wrapper">
          <div class="container">
            <div class="row">
              <div class="col-lg-12">
                <h2>Contact Us</h2>
              </div>
            </div>
          </div>
        </section>
        <section class="wrapper custom-wrapper">
          <div class="container">
            <div class="row">
              <div class="col-sm-6">
                <div class="quote-form clearfix">
                  <form action="" method="post" enctype="multipart/form-data">
                    <div class="form-group required">
                      <label for="input-name">Your Name</label>
                      <input type="text" name="name" value="" id="input-name" class="form-control" />
                    </div>
                    <div class="form-group required">
                      <label for="input-email">E-Mail Address</label>
                      <input type="text" name="email" value="" id="input-email" class="form-control" />
                    </div>
                    <div class="form-group required">
                      <label for="input-enquiry">Enquiry</label>
                      <textarea name="enquiry" rows="10" id="input-enquiry" class="form-control"></textarea>
                    </div>
                    <div class="buttons">
                      <input class="btn btn-primary btn-lg" type="submit" value="Submit" />
                    </div>
                  </form>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="contact-info">
                  <h3>Techno web solution</h3>
                  <ul class="list-unstyled">
                    <li> <i class="fa fa-location-arrow"></i> 914/1, M.B Road, Phase - 3<br />
                      Kolkata: 700051<br />
                      West Bengal, India </li>
                    <li><i class="fa fa-phone"></i> +91 98360 44395</li>
                    <li><i class="fa fa-envelope"></i> <a href="mailto:info@technowebsol.com">info@technowebsol.com</a></li>
                    <li><i class="fa fa-globe"></i> <a target="_blank" href="http://www.technowebsol.com">www.technowebsol.com</a></li>
                  </ul>
                  <div class="qr-scan"> <img src="assets/images/qr.png" alt="QR" class="img-responsive" /> </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
    </>
  )
}

export default ContactUs